import * as FileSaver from "file-saver";
import * as XLSX from "sheetjs-style";
import { Button } from "antd";
import { FaFileExcel } from "react-icons/fa";
import { useTranslation } from "react-i18next";

export const ReportExcel = (dataSet) => {
  const { t } = useTranslation("global");

  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

  const exportToExcel = async () => {
    const ws = XLSX.utils.json_to_sheet(dataSet.dataSet);

    for (const cellAddress in ws) {
      if (cellAddress.startsWith("!")) continue;

      ws[cellAddress].s = {
        alignment: { horizontal: "center", vertical: "center" },
        border: {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        },
      };

      if (cellAddress.includes("1") && cellAddress.length <= 2) {
        ws[cellAddress].s.fill = {
          fgColor: { rgb: "389e0d" },
        };
        ws[cellAddress].s.font = { sz: 14, bold: true };
      }
    }

    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, `${dataSet.fileName}.xlsx`);
  };

  return (
    <Button
      type="primary"
      shape="round"
      onClick={exportToExcel}
      icon={<FaFileExcel />}
      style={{
        backgroundColor: "#389e0d",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        padding: "0 20px",
      }}
    >
      {t("reports.excel")}
    </Button>
  );
};

export default ReportExcel;
